import { Link } from '@tanstack/react-router'
import { useDocumentTitle } from '../shell/document-title.ts'

/**
 * Not found — §18.3.
 *
 * **One page, one sentence, everywhere.** An unknown route, a tenant id that does not exist
 * and a tenant id that is not even shaped like one all render this and nothing else, because
 * distinguishing them tells a visitor which ids exist. It used to be two pages: this one,
 * for the router, and a differently-worded copy written inline on each of the four tenant
 * screens — so what a stranger read depended on *which* URL they had guessed, which is the
 * very thing the page exists not to reveal. The tenant screens now return this component
 * (P05, 2026-10-13).
 *
 * It names nothing it was asked for: no id, no slug, no "that tenant".
 */
export function NotFoundScreen() {
  useDocumentTitle('Not found')

  return (
    <main className="page page-narrow">
      <div className="panel">
        <h1>Not found</h1>
        <p>There is nothing at that address. It may have been removed, or the link may be wrong.</p>
        {/*
          Exact, because this page's own address is usually *under* /tenants (a tenant that
          is not there), and a link back to a page the reader is "in" is not the current
          page — it would otherwise announce itself as `aria-current="page"`.
        */}
        <Link to="/tenants" className="button" activeOptions={{ exact: true }}>
          Back to Tenants
        </Link>
      </div>
    </main>
  )
}
